<template>
  <div class="is-jikangai edit-item" v-if="editingData && options">

    <div class="head"><b>時間外及び休日労働</b></div>
    <div class="data">
      <!-- 
        PMの場合は「有」として固定
        https://imp-hd.backlog.com/view/MEDICA_AS-763 
      -->
      <select-box :options="options?.boolean_type" v-model="editingData.is_jikangai" class="small"
        :disabled="editingData.syozoku_id === OptionConst.SYOZOKU.PM || disabled"></select-box>

      <p class="current-data" v-if="currentData?.is_jikangai === true">有</p>
      <p class="current-data" v-else-if="currentData?.is_jikangai === false">無</p>
      <template v-if="editingData.is_jikangai === true">
        <p v-if="editingData.syozoku_id === OptionConst.SYOZOKU.PM" class="pre">{{ Message.WITHOUT_WORKTIME_PM }}</p>
        <p v-else-if="editingData.syozoku_id === OptionConst.SYOZOKU.PG" class="pre">{{ Message.WITHOUT_WORKTIME_PG }}</p>
      </template>
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';
import OptionConst from '@/const/Option';
import Message from "@/const/KoyouKeiyaku/Message";

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError,
      OptionConst,
      Message
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';
</style>
